import { itemTemplate } from '@/libs/autocomplete/template'
import * as autoComplete from '@frontend/autocomplete-pixabay/auto-complete.min'

export class AutoComplete {
  private instance: autoComplete = null

  public constructor(options: object) {
    this.instance = new autoComplete({
      renderItem: (item: string) => itemTemplate(item),
      ...options,
    })
  }

  public destructor() {
    if (this.instance) {
      this.instance.destroy()
    }
  }
}
